import "./../css/sass/styles.scss";
import * as Turbo from "@hotwired/turbo";
import "./Utility/background-music";
import { debouncer, documentReady, scrollToEl, index, playAudioSync, playBGMusic, pauseBGMusic } from "./Utility/utils";
import "./components/slider";
import "./components/mousetracker";
import "./components/video";
import "./components/modal";
import "./components/accordion";
import "./components/nav";
import "./components/site-intro";
import "./components/featured-post-intro";
// import "./components/cursors";
import "./components/fluid-text";
import "./components/animations";

// blocks
import "./blocks/articles-grid";
import "./components/articles-slider";
import "./components/timeline";

import imagesLoaded from "imagesloaded";

import { createApp } from "petite-vue";
import { postFeed } from "./blocks/articles-grid";
import { accordionFeed } from "./components/accordion";
import { peopleFeed } from "./components/people-grid";

// Use this for all your js need
documentReady((event) => {
  createApp({
    postFeed,
    accordionFeed,
    peopleFeed,
  }).mount();

  const body = document.querySelector("body");

  // Handle curtain in with Turbo.js navigation
  document.addEventListener("turbo:click", () => {
    body.classList.add("loading");
    body.classList.remove("show_intro");
  });

  document.addEventListener("turbo:load", () => {
    body.classList.remove("loading");
    setTimeout(function () {
      const body = document.querySelector("body");
      body.classList.remove("loading");
    }, 250);
  });

  // Remove empty p tags accidentally placed by wordpress editor
  var elements = document.querySelectorAll("p");
  Array.prototype.forEach.call(elements, function (el, i) {
    let content = el.innerHTML;
    content = content.replace(/\s+/g, "");
    if (!content) {
      el.parentNode.removeChild(el);
    }
  });

  // Hero Scroll Buttons
  const heroScrollDown = document.querySelector(".hero .scroll-down-hex");
  if (!!heroScrollDown) {
    heroScrollDown.addEventListener("click", function (e) {
      const hero = document.querySelector(".hero");
      const heroContent = hero.querySelector(".hero__content_container");
      let next = hero.nextSibling;
      if (heroContent) {
        scrollToEl(heroContent);
      } else if (!!next) {
        next = next.nodeType != 1 ? next.nextSibling : next;
        scrollToEl(next);
      }
    });
  }

  // Smooth Scrolling Anchor links / Prevent Default on href="#" links
  document.addEventListener(
    "click",
    function (e) {
      // loop parent nodes from the target to the delegation node
      for (var target = e.target; target && target != this; target = target.parentNode) {
        if (target.matches("a")) {
          const href = target.getAttribute("href");
          if (/^#/.test(href)) {
            const hash = href.substring(href.indexOf("#"));
            const hashTarget = document.getElementById(hash.substring(1));
            if (hash !== "#" && hashTarget && !hashTarget.classList.contains("modal")) {
              e.preventDefault();
              target.blur();
              scrollToEl(hashTarget);
            } else if (hash == "#") {
              e.preventDefault();
              target.blur();
            }
          }
          break;
        }
      }
    },
    false
  );

  // Add stagger-left or stagger-right classes to span elements to allow for CSS styling of left or right staggering by line.
  function staggerText() {
    const staggerElements = document.querySelectorAll(".staggerText");
    if (!!staggerElements) {
      staggerElements.forEach((el) => {
        // Get starting direction
        let direction = el.getAttribute("data-direction") ? el.getAttribute("data-direction") : "left";

        // Get each individual word that's wrapped in a span. We'll check for where the line breaks and add classes accordingly.
        const staggerElements = el.querySelectorAll(".offset_text_el");

        // linePos will track which line we're in, letting us know when to switch from left to right, or right to left.
        let linePos;

        // furthestLeft and furthestRight will determine the furthest most left and right words,
        // to help center the whole text block, if it has the .centered class.
        const elCenter = el.offsetWidth / 2;
        let furthestLeft = elCenter;
        let furthestRight = elCenter;
        // const elStyle = el.computedStyleMap();
        const staggerAmount = parseInt(getComputedStyle(el).getPropertyValue("--stagger-amount"));

        if (!!staggerElements) {
          // Determine left/right class designation for each word.
          let i = 1;
          staggerElements.forEach((word) => {
            const wordIndex = index(word);

            // In case elements are already positioned, we'll reset them to start fresh.
            word.classList.remove("direction-left");
            word.classList.remove("direction-right");
            word.classList.remove("stagger-first");
            word.classList.remove("stagger-last");

            const wordPos = word.offsetTop;

            // if we're on the first word, we'll use that as the start of measuring linePos and horizontal positioning
            if (i == 1) {
              linePos = wordPos;
            }

            // Check wordPos against linePos to determine direction class
            if (wordPos > linePos) {
              direction = direction == "left" ? "right" : "left";
              linePos = wordPos;
              word.classList.add("stagger-first");
              const prevWordIndex = i - 2;
              staggerElements[prevWordIndex].classList.add("stagger-last");
            }
            word.classList.add("direction-" + direction);

            // Ensure the text block as a whole is centered, if it has the class for it.
            if (el.classList.contains("centered")) {
              const wordLeft = direction == "left" ? word.offsetLeft - staggerAmount : word.offsetLeft + staggerAmount;
              const wordRight = wordLeft + word.offsetWidth;

              if (wordLeft < furthestLeft) {
                furthestLeft = wordLeft;
              } else if (wordRight > furthestRight) {
                furthestRight = wordRight;
              }
            }

            i++;
          });

          // Apply centering css properties if needed
          if (el.classList.contains("centered")) {
            // Find center point between left and right most words
            const wordsCenter = furthestLeft + (furthestRight - furthestLeft) / 2;
            const elTransform = elCenter - wordsCenter;
            el.style.setProperty("--stagger-center-transform", elTransform + "px");
          }
        }
      });
    }
  }
  staggerText();

  window.addEventListener(
    "resize",
    debouncer(function () {
      setTimeout(function () {
        staggerText();
      }, 100);
    }, 15)
  );

  // Audio Sync Trigger Click
  const as_buttons = document.querySelectorAll(".audioSync__trigger");
  if (as_buttons) {
    as_buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        button.blur();
        const as_Wrap = button.closest(".audioSync");
        button.classList.add("clicked");

        if (!!as_Wrap) {
          playAudioSync(as_Wrap);
        }

        // If it's not in the site intro component, scroll to the text
        if (!button.closest(".site_intro") && !button.closest(".featured_intro")) {
          const text = as_Wrap.querySelector(".audioSync__text");
          scrollToEl(button);
        }
      });

      // There's a bug where the video overlay sometimes doesn't play.
      // Let's check if it's playing and if not, start it. 
      setTimeout(() => {
        const buttonVideo = button.querySelector('video');
        if (buttonVideo.paused) {
          buttonVideo.play;
        }
      }, 2000); 
    });
  }

  // Set CSS Property for window width, to be more accurate than just using '100vw'
  let bodyWidth = body.offsetWidth + "px";
  body.style.setProperty("--body-width", bodyWidth);
  document.documentElement.style.setProperty("--body-width", bodyWidth);
  window.addEventListener(
    "resize",
    debouncer(function () {
      bodyWidth = body.offsetWidth + "px";
      document.documentElement.style.setProperty("--body-width", bodyWidth);
    }, 30)
  );
});

window.addEventListener("load", function (event) {
  const bodyEl = document.getElementsByTagName("body")[0];
  var event = new CustomEvent("pageloaded");
  bodyEl.classList.remove("loading");
  document.dispatchEvent(event);

  // Play/Pause background music
  const bg_audio_trigger = document.querySelector(".site_audio__trigger");
  if (!!bg_audio_trigger) {
    if (!!bg_audio_trigger && !bg_audio_trigger.classList.contains("clicked")) {
      bg_audio_trigger.addEventListener("click", function () {
        bg_audio_trigger.blur();
        bg_audio_trigger.classList.add("clicked");

        if (!bg_audio_trigger.classList.contains("active")) {
          playBGMusic();
        } else {
          pauseBGMusic();
        }
      });
    }
  }

  // Preload images
  const preloadImages = () => {
    return new Promise((resolve, reject) => {
      var imgLoad = imagesLoaded(
        document.querySelectorAll("img"),
        {
          background: true,
        },
        resolve
      );
    });
  };
  // preloadImages().then(() => {
  //   const bodyEl = document.getElementsByTagName("body")[0];
  //   var event = new CustomEvent("pageloaded");
  //   bodyEl.classList.remove("loading");
  //   document.dispatchEvent(event);
  // });
});
